import { apiPost } from "../baseApi";

export const signup = async (data) => {
  try {
    const response = await apiPost("_signup", data);
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
